<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
      <div id="echartsType" class="chart-container"></div>
    </div>
  </div>

</template>

<script>
import * as echarts from 'echarts';
import { getTrendList } from '@/api/bi'


export default {
  name: "echartsNine",
  data(){
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
      dataLeft: [],
      dataRight: []
    }
  },
  props: ['params'],
  mounted() {
    this.chart = echarts.init(document.getElementById('echartsType'));
    // this.initBar(this.params[0]);
    this.loading = true
  },
  watch: {
    params: function (val, oldVal) {
      this.initBar(val[0])
    }
  },
  methods:{
    setData(){
      let dataLeft = []
      let dataRight = []
      this.params[0].growth_analysis.forEach(item => {
        dataLeft.push({
          value: -item.year1_amount,
          name: item.segment
        })
        dataRight.push({
          value: item.year2_amount,
          name: item.segment
        })
      })
      this.dataLeft = dataLeft
      this.dataRight = dataRight
    },
    initBar(row){
      this.loading = true
      this.setData()
      const _this = this;
      let names = _this.dataLeft.map(item => item.name);
      var option = {
            title: {
                text: '',
                subtext: '',
                left: 'center',
                textStyle: {
                    fontSize: 18,
                    color: '#FFF'
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: function(params) {
                    // 格式化tooltip，显示绝对值
                    if(params.length){
                      let str = ''
                      let name = params[0].name;
                      str += `${name}<br/>`;
                      params.forEach(item => {
                        str += `${item.seriesName}: ${Math.abs(item.value).toLocaleString()}元 <br/>`;
                      })
                      // let value1 = Math.abs(params[0].value).toLocaleString();
                      // let value2 = Math.abs(params[1].value).toLocaleString();
                      // let str = ''
                      // str += `${params[0].name}<br/>`
                      // str += `${params[0].seriesName}: ${value1} 元 <br/>`;
                      // str += `${params[1].seriesName}: ${value2} 元`;
                      return str
                    }
                    
                }
            },
            legend: {
              textStyle: {
                color: "#FFFFFF", // 白色文字
              },
              selectedMode: false,
              padding: [20, 0, 20, 0], // 设置legend上下间距
            },
            grid: {
                left: '5%',
                right: '10%',
                bottom: '15%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                name: '销售额(元)',
                nameTextStyle: {
                    color: '#fff',
                    fontSize: 18
                },
                axisLabel: {
                    color: '#fff',
                    formatter: function(value) {
                        // 显示绝对值
                        return Math.abs(value).toLocaleString();
                    }
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#fff',
                        width: 2
                    }
                },
                splitLine: {
                    lineStyle: {
                        type: 'dashed'
                    }
                }
            },
            yAxis: {
                type: 'category',
                data: names,
                axisLine: {
                    show: true,
                    color: '#fff'
                },
                axisLabel: {
                  inside: false, // y轴名字是否显示在柱状图里面
                  zlevel: 2,
                  color: '#fff' // y轴名字颜色
                },
                splitLine:{
                  lineStyle: {
                    color: '#fff'
                  }

                }
            },
            dataZoom: [
              {
                type: 'slider',
                start: 0,//数据窗口范围的起始百分比0-100。
                end: 100,//数据窗口范围的结束百分比0-100。
                labelStyle: {
                  color: '#FFF'
                },
                label: {
                  show: true,
                  color: '#FFF' // 默认字体颜色
                },
                textStyle: { 
                  color: '#FFF'
                },
                emphasis: {
                  label: {
                    color: '#FFF' // 默认字体颜色
                  },
                }
              },
              // {
              //     type: 'inside',      // 内置型数据缩放（支持鼠标滚轮缩放）
              //     start: 0,
              //     end: 100
              // }
            ],
            series: [
                {
                    name: `${row.chart_data.year1}年`,
                    type: 'bar',
                    data: _this.dataLeft.map(item => item.value),
                    itemStyle: {
                        color: '#54ced0'
                    },
                    label: {
                        show: true,
                        position: 'left',
                        color: '#fff',
                        formatter: function(params) {
                            return (Math.abs(params.value) / 10000).toFixed(1) + '万';
                        }
                    }
                },
                {
                    name: `${row.chart_data.year2}年`,
                    type: 'bar',
                    data: _this.dataRight.map(item => item.value),
                    itemStyle: {
                        color: '#c4b7de'
                    },
                    label: {
                        show: true,
                        color: '#fff',
                        position: 'right',
                        formatter: function(params) {
                          return (Math.abs(params.value) / 10000).toFixed(1) + '万';
                        }
                    }
                }
            ]
        };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
      // // 隐藏加载效果
      // setTimeout(()=> {
      //   this.loading = false;
      // }, 2000)
      this.loading = false
    },
  },
}
</script>

<style scoped>
.outBox {
  width: 100%;
  height: 620px;
  /*border: 1px solid #4688ff;*/
}

.box {
  width: 100%;
  height: 620px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}


</style>